import Cookies from 'js-cookie';

const LegalPopup = {
	cookieName: 'legal_cookie',
	popup: null,
	popupAccept: null,
	init: () => {
		LegalPopup.popup = document.querySelector('[data-legal-popup]');
		LegalPopup.popupAccept = document.querySelector('[data-legal-popup-accept]');
		if(!LegalPopup.popup || !LegalPopup.popupAccept) return;
		LegalPopup.checkCookie();
		LegalPopup.popupAccept.addEventListener('click', LegalPopup.acceptLegalNotice)
	},

	checkCookie: () => {
		LegalPopup.setLegalPopupVisibility(!Cookies.get(LegalPopup.cookieName))
	},
	setLegalPopupVisibility: (state) => {
		LegalPopup.popup.classList.toggle('active', state);
	},

	acceptLegalNotice: () => {
		Cookies.set(LegalPopup.cookieName, '1', { expires: 365 })
		LegalPopup.setLegalPopupVisibility(false);
	}

}
export default LegalPopup;
